import styled from 'styled-components';
import Select from 'react-select'

export const Container = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
` 
export const SelectReact = styled(Select)`
` 